import React from 'react';
import IfRouterOpen from '../../hook/IfRouterOpen';

const Aboutarchitecture = () => {
   const routerOpen = IfRouterOpen()
   return (
      <div className='About-architecture flexCenter' style={{ transform: `translateY(${routerOpen ? '0px' : '500px'})` }}>
         <div>
            <img src={require("../../img/about4.jpg")} alt="" />
            <h1>Architecture</h1>
            <p>“매일 같이 물을 주도록 해라. 제자는 매일 아침에 산에 올라 죽은 나무에 물을 주고 저녁이 되어서야 수도원에 돌아오곤 했지. 그렇게 3년간 물을 주다 나무에 꽃이 만발한 것을 발견했단다. 매일 같이 같은 시간, 같은 행동의 반복을 의식처럼 한다면, 세상은 변하게 될 거야.”</p>
            <span>- 안드레이 타르코프스키의 [희생] 중에서</span>
            <p>모든 일은 한 번에 변화하는 법이 없습니다. 급박한 변화는 마치 죽은 나무를 살리는 일에 조화(造花)를 달아두는 것과 같습니다. 매일 조금씩 실천하는 작은 행동에서 비롯된 큰 변화를 지향해야 합니다. LCDC SEOUL의 공간은 이 시대의 흐름을 읽어내고, 공간을 세심하게 분석하고, 사람들을 만나고 어울리며, 조금씩 스며들 수 있는 새로운 가능성을 제시합니다.</p>
         </div>
         <div>
            <h1>Philosophy</h1>
            <p>대지 표면의 시작점, <br />
            새로운 생태계를 위한 양질의 대지를 만들어내는 일, <br />
            기존의 살아있던 환경을 남기면서 새로운 생태계가 자리 잡을 수 있도록. <br />
            공간의 목적이 변화함에 따라 기존의 질서와 새로이 자립할 수 있는 지금 사이 관계의 미묘한 개방을 통해 명백하게 견고한 환경을 구축해나갑니다.</p>
         </div>
         <div>
            <h1>Site</h1>
            <p>서울 시내에 자리하는 준공업지역 성수동은 효율을 제일 가치로 발전해 온 근대 도시 공장지대의 상징입니다. 하지만 IT 기술이 산업 패러다임을 급격히 변화시키는 동시에, 유수의 신생 브랜드들이 성수동으로 이주하며 최근 급격히 모습을 바꾸고 있습니다.</p>
            <p>기름 냄새와 기계음이 익숙한 장소. 오랜 시간 특유의 향이 밴 그곳. <br />
            성수동 2가에 위치한 자동차 정비 공장과 구두 공장 그리고 그 안에 흐르고 있는 공간의 역사와 사람들에 뿌리를 두고 새로운 이야기의 가지들이 뻗어 나갈 수 있도록 노력했습니다. <br />
            LCDC SEOUL에서의 시간은 오랜 시간 공장지대가 만들어 낸 공업 미학 뿐 아니라, 새로운 디자인의 감성이 입혀진 공간을 음미하는 즐거운 경험이 될 것입니다.</p>
         </div>
         <div>
            <img src={require("../../img/about5.jpg")} alt="" />
            <h1>Square</h1>
            <p>스퀘어는 흩어져 있는 ‘각 층과 실 - 중정 - 환경’의 맥락을 관통하는 만남의 장을 만들어냅니다. 공간이 지니고 있는 볼륨과 공간의 각기 다른 성격. 공간을 둘러싼 틀은 통일감을 이루며, 서로간의 경계를 넘나드는 개방감을 제안합니다. 또한 수평적 통일감은 수직적 위계질서를 무너뜨리고 어느 한쪽 측면의 독점적인 우월함이 없이 하나의 세계관을 지니게 합니다.</p>
         </div>
         <div>
            <img src={require("../../img/about6.jpg")} alt="" />
            <h1>Lighting</h1>
            <p>이야기들은 낮보다 밤에 더 깊어질 수 있습니다. 빛은 사람들을 현실 세계와 분리시켜 전혀 다른 체험을 가능케 하는 배경으로 작용하기도 합니다. 건축적 의도를 완벽하게 이해하고 설치된 빛의 볼륨들은 조형적 아름다움을 배가시키는 것은 물론, 공장지대 속 밤의 풍경을 따뜻하게 바꾸는 랜드마크가 되도록 설계하였습니다.</p>
            <p>다양한 이야기들로 자칫 혼란해지기 쉬운 공간과 브랜드들을 자연스럽게 연결시키며, 동시에 각각의 브랜드와 공간의 위계와 개성들이 흐려지지 않도록, 나아가 사람들을 편하게 이끄는 방향으로 빛의 온도와 밝기, 강약들이 디자인되었으며, 시간과 계절의 리듬을 반영할 수 있는 스페셜 프로그램도 준비되었습니다.</p>
            <p>LCDC SEOUL다운 공기의 흐름을 만들어 내는 빛은 공간을 찾는 이들의 이야기를 한층 새롭고 풍요롭게 할 것입니다.</p>
         </div>
         <div>
            <h1>Landscape</h1>
            <p>조경은 공간의 영혼이 짓는 표정입니다. 우리가 매 순간 다른 표정을 지어내듯이, 식물도 매일 다른 표정으로 공간의 이야기를 만들어갑니다. 그래서 식물이 만들어내는 공간은 단 한순간도 같을 수 없습니다. 식물들은 공간과 사람들로부터 값진 언어를 먹고 자라 자신의 표정이 담긴 이야기를 다시 만들어냅니다. 이렇듯 시간이 흘러갈수록 우리 모두와 함께 더욱더 단단하고 면밀한 이야기를 피워낼 것입니다.</p>
            <p>LCDC SEOUL의 공간을 이동한다는 것은 단순히 공간의 이동보다는 감각의 이동을 뜻합니다. LCDC SEOUL의 빈 스퀘어를 들어서는 순간 커다란 핀오크 나무 한 그루가 짓는 표정을 통해 새로운 감각의 이동을 경험하게 될 것입니다. B동의 외부 계단을 따라 올라가면 풍성하게 조성된 허브 정원과 부드러운 억새류가 자리하는 옥상 정원이 나오며, 공간을 아우르는 섬세한 미감과 후각적으로 가득 담기는 포근함을 마주하게 됩니다.</p>
            <p>LCDC SEOUL의 끝맺음에 자리하는 루프 탑으로 향하는 길. 자연스럽게 닿는 허브의 향을 따라 발걸음을 옮기다 보면, 그 끝에서는 미각을 자극하는 향기로운 개화 나무가 자리하는 바의 프라이빗 정원을 경험할 수 있습니다. LCDC SEOUL에 찾아와 공간과 식물들이 만들어내는 감각의 이동을 경험해 보시기 바랍니다.</p>
         </div>
      </div>
   );
};

export default Aboutarchitecture;